import { Constants } from "../functions/constants";
import { CookieUtils } from "../functions/cookie-utils";
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { RouteUtils } from "../functions/route-utils";
import aa from 'search-insights'
import ClickOutside from 'vue-click-outside';

const algoliaAutocompleteMixin = {
    directives: {
        ClickOutside
    },
    computed: {
        pageContext: function () {
            var context = RouteUtils.ensureNoLeadingSlash(RouteUtils.ensureNoTrailingSlash(window.location.pathname)).replaceAll("/", "_");
            if (context.length == 0)
                context = 'home'

            return [context];
        },
        editContext: function () {
            var path = window.location.pathname;

            if (path.indexOf('Sitefinity/adminapp/pages/') > -1) {
                path = path.substr(26);

                return [RouteUtils.ensureNoLeadingSlash(RouteUtils.ensureNoTrailingSlash(path.substr(0, path.indexOf('/Action/')))).replaceAll("/", "_")];
            }
            else if (path.indexOf('/Action/') > -1) {
                return [RouteUtils.ensureNoLeadingSlash(RouteUtils.ensureNoTrailingSlash(path.substr(0, path.indexOf('/Action/')))).replaceAll("/", "_")];
            }

            return [];
        },
        suggestionClickLabel: function () {
            return Constants.EVENTS.ALGOLIA.AUTOCOMPLETE.SUGGESTION_CLICKED;
        },
        searchTerm: function () {
            return this.search_term;
        },
        resultsHeading: function() {
            if (this.indexName == this.equipmentIndexName)
                return 'Equipment';
            else if (this.indexName == this.partsIndexName)
                return 'Parts';
            else if (this.indexName == this.resourcesIndexName)
                return 'Resources';
            else if (this.indexName == this.contentIndexName)
                return 'Pages';
            else
                return '';
        },
        resultsLabel: function() {
            if (this.indexName == this.equipmentIndexName)
                return 'equipment';
            else if (this.indexName == this.partsIndexName)
                return 'parts & supplies';
            else if (this.indexName == this.resourcesIndexName)
                return 'resources';
            else if (this.indexName == this.contentIndexName)
                return 'web pages';
            else
                return '';
        },
        hashLink: function () {
            if (this.indexName == this.equipmentIndexName)
                return 'equipment';
            else if (this.indexName == this.partsIndexName)
                return 'parts';
            else if (this.indexName == this.resourcesIndexName)
                return 'resources';
            else if (this.indexName == this.contentIndexName)
                return 'pages';
            else
                return '';
        }
    },
    methods: {
        onClick: function (hit, sendEvent, label) {
            if (hit && sendEvent)
                sendEvent(Constants.EVENTS.ALGOLIA.TYPES.CLICK, hit, label);

            if (hit.pageurl)
                if (hit.__queryID && hit.item_type)
                    window.location.href = `${RouteUtils.ensureNoTrailingSlash(hit.pageurl)}?aqid=${hit.__queryID}`;
                else
                    window.location.href = `${RouteUtils.ensureNoTrailingSlash(hit.pageurl)}`;
            else if (hit.relative_url_path)
                window.location.href = `${RouteUtils.ensureNoTrailingSlash(hit.relative_url_path)}`;
        },
        hashQuery: function (hash) {
            const urlObj = window.location;
            const urlParameters = RouteUtils.getQueryParams();
            const basePath = `${urlObj.protocol}//${urlObj.host}${this.searchPageUrl}`;
            const url = basePath + '?query=' + this.searchTerm + hash;
            window.location.href = url; 

            if (this.searchPageUrl == urlObj.pathname && urlParameters.get('query') == this.searchTerm) {
                 setTimeout(() => { window.location.reload(); }, 200);
             }
        },
        searchChanged: function (term) {
            this.search_term = term;
        },
        initializeAutocompleteInsights: function () {
            let id = CookieUtils.getCookie(Constants.COOKIES.INSIGHTS_ID);

            if (id) {
                var insightsMiddleware = createInsightsMiddleware({
                    insightsClient: aa,
                });

                this.middlewares = [insightsMiddleware];
                aa('setUserToken', `${id}`);
            }
        },
        cleanSearch: function () {
            if (this.currentAutocomplete && (this.search_term != null || this.isOpen)) {
                this.search_term = null;
                this.currentAutocomplete.setIsOpen(false);
                this.currentAutocomplete.setQuery('');
                this.currentAutocomplete.refresh();
            }
        },
        getResourceThumbnailUrl(resource) {
            let thumbnailUrl = Constants.IMAGES.DEFAULT_THUMBNAIL_STATIC_URL;

            if (resource.image) {
                thumbnailUrl = resource.image;
            }
            else if (resource.youtube_object?.Thumbnail) {
                thumbnailUrl = resource.youtube_object.Thumbnail;
            }
            else if (resource.youtube_object?.thumbnails?.length) {
                thumbnailUrl = resource.youtube_object.thumbnails[0].url;
            }

            return thumbnailUrl;
        },
        doQuery: function (keyword) {
            window.location.href = this.getQueryUrl(keyword);
        },
        getQueryUrl: function (keyword) {
            var basePath = this.searchPageUrl || location.pathname;
            var url = basePath + '?query=' + keyword;

            return url;
        },
    },
    watch: {
        searchTerm: {
            handler: function (newVal, oldVal) {
                if (newVal && window.isMobile) {
                    setTimeout(() => {
                        const el = this.$refs.suggestions
                        const allList = el.querySelector('.autosuggest-menu__list');
                        el.classList.toggle('hasScroll', allList.offsetHeight - 100 > el.offsetHeight)

                        let lastScrollTop = 0;
                        el.onscroll = (e)=>{
                            const shouldHaveIndicator = allList.offsetHeight - 100 > el.offsetHeight;
                            if (el.scrollTop < lastScrollTop){
                                el.classList.toggle('hasScroll', shouldHaveIndicator)
                                return;
                            } 
                            lastScrollTop = el.scrollTop <= 0 ? 0 : el.scrollTop;
                            if (el.scrollTop + el.offsetHeight >= el.scrollHeight){
                                el.classList.remove('hasScroll')
                            }
                        }
                    }, 500)
                }
            }
        }
    },
    mounted() {
        this.$on('reset-search', this.cleanSearch)
    },
};

export default algoliaAutocompleteMixin;
